/**
 * Core Checkbox — wraps Radix Checkbox for accessibility + theme integration.
 */
import React from 'react';
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface CheckboxProps {
  id?: string;
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  className?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({ id, checked, onCheckedChange, disabled, label, className }) => (
  <div className={cn("flex items-center gap-2", className)}>
    <RadixCheckbox.Root
      id={id}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      className="peer h-4 w-4 shrink-0 rounded border border-slate-300 dark:border-slate-600 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-[var(--primary-color)] data-[state=checked]:border-[var(--primary-color)] data-[state=checked]:text-white"
    >
      <RadixCheckbox.Indicator className="flex items-center justify-center text-current">
        <Check className="h-3 w-3" />
      </RadixCheckbox.Indicator>
    </RadixCheckbox.Root>
    {label && <label htmlFor={id} className="text-sm text-gray-700 dark:text-slate-300 cursor-pointer select-none">{label}</label>}
  </div>
);
export default Checkbox;
